<script>
	import { metatags } from "@roxi/routify";
	$: metatags.title = `Written | Mustafa Gülsün - Front-end Developer`;
</script>

<main id="main">
	<section class="container written">
		<h1>Written</h1>
		<p>However hard to make sense with some of these, I wrote them.</p>
		<h2>Poems</h2>
		<h3 id="morning">Morning Routine</h3>
		<p>
			I wanna join to your morning routine,<br />
			watch you combing your hairs,<br />
			see you on your mirror standing behind you,<br />
			I want to hold your waist and make this morning dance with you,
			<br />
			<br />

			I watch your pyjamas off and how you sneak in your jeans,<br />
			Then what do you do to your lips, and some other things that I don't know,
			<br />
			<br />
			your naked foot steps in a sweet rush<br />
			as you walk to your door, <br />
			where your favourite shoes are,<br />
			how clumsy it is, falling down your heels,<br />
			as your telephone rings, you say "hello" to your lover,<br />
			Then I disappear in my dreams,<br />
			I disappear in my own dreams.<br />
		</p>

		<h3 id="hurt">How many times you can hurt me</h3>
		<p>
			Don't feel hopeless,<br />
			Just stand up again,<br />
			Pretend like nothing has happened<br />
			No, you have not been funny<br />
			No, your selfesteem has not been wounded<br />
			You need to stand up, you need to be strong<br />
			Just to fall down again, you need that hope.<br />
		</p>

		<h3 id="gray">Gray</h3>
		<p>
			My prison fenced with gray,<br />
			Everywhere I stare there is something common<br />
			Sky pierced with prays, leaks blues to the sea,<br />
			The reflections over faces, holes are on the bodies,<br />
			Wherever I turn, no one can't miss the play,<br />
			What I miss is gray, what I think is gray,<br />
			What I dream is gray, what I want is gray...<br />
		</p>

		<h3 id="substance">Strange Substance</h3>
		<p>
			Earth divides in two, light is swallowed by darkness,<br />
			shadows cover the bliss, colors become fade, <br />
			air becomes the poison of your pity fate, <br />
			while drawing images, into your sanity,<br />
			paranoia capturing you, cannot stop thinking, <br />
			fooling with hopes, like a child plays<br />
			eyes looking at you, frozen blood in veins,<br />
			tighter your skin the more you suffocate,<br />
			it wants to get out within your every breath,<br />
			your mind is lost when your body is awake,<br />
			a strange substance, growing inside you,<br />
			memories buried in graves, destinations are late,<br />
			words that are never said, feelings that have changed<br />
			in these barren lands, what alive became dead,<br />
			within a single blink, you have never existed.<br />
		</p>

		<div class="is-hidden">
			<i>This poem (lyrics) is still currently on work.</i><br />
			edit: sounds so lame now in 2011, must edit!, edit : year 2013 -_-, edit: year
			2021 :D,
			<br /><br />

			Draw an imagination, with pencil of my sanity,<br />
			Fooled with the hopes, I am on a run to you, <br />
			Whip me with the sorrow, be salt of the torture,<br />
			Abyss is my fortune, please push me into,<br />
			Make the pain endless, you are not mine, anyway <br /><br />

			Turning your face away with wind that blows an unknown,<br />
			No way, there is no existence, when you are away<br />
			Earth be divided in two, light get swallowed by the darkness,<br />
			if there is no smile of you<br /><br />

			Myself is lost awake, here my body stands,<br />
			It's a lucid dreaming, arrival is nowhere<br />
			Put me in the four walls, let the lies fill in<br />
			You be my door locked, watch me drown in<br />
			Let me be in your dreams , when i am gone<br /><br />

			Slip your dress away, lie on the bed, <br />
			I feel so near, but I can't touch anyway,<br />
			Gray eyes looking at me, like frozen blood in the vein<br />
			Shadows cover the bliss, put death into hearts,<br />
			if you are not mine, this world can't last<br /><br />

			I never heard of love, maybe never will<br />
			your words in my head, hardly ever real<br />
			i need to get out, i feel the strange substance<br />
			my skin is so tight, that makes me suffocate,<br />
			air be the poison, of my every breath<br /><br />

			And the trust left the stage, fears on the scene<br />
			paranoia captured me, can't stop thinking<br />
			paint the soil black, colors become fade,<br />
			in this barren lands, bury me in a grave,<br />
			in your mind of confusion, where a children plays...<br />
		</div>

		<div class="is-hidden">
			<h3>İnci</h3>
			cehennem bir çölde hasretin çekerken, kuru dudağımdan akan kan kuma damlar,<br
			/>
			damarlarım çekilmiş,<br />
			gözlerim kan çanak seni düşünürken,<br />
			gelip geçen kum fırtınalarından haberin bekler gibi olup,<br />
			her vahayı esten geçerken,<br />
			sana doğru koşar adım yaklaşmanın verdiği hazın kursağımda kaldığı an vebalini
			anladığımdır,<br />
			içimin parçalanışını, susuzluktan kuruyan damarlarımın çatırdısı cefanı dinleyerek,<br
			/>
			yavaş yavaş güneşe doğru sonsuz boşluğa dönüp,<br />
			hayatımın sensiz anlamsızlığını haykırmak....<br />
		</div>

		<div class="is-hidden">
			<h3>Terslem</h3>
			Ölümü getireceğim sana demet demet koparıp bahar bahçelerinden<br />
			Ayrılık koklayacaksın beyaz yapraklı kır papatyalarımdan<br />
			Korku saracak içini sıcak meltemlerim estiğinde<br />
			Koparıp götürecek ruhumu bedeninden ben bitti dedim mi<br /><br />

			Değişen birşey yok canım o güzel hayatında<br />
			Hasretim biter, sevgim gider, ellerim dokunmaz tenine<br />
			Anılar bıraksam da, gözlerinde matem, içinde boşluk<br />
			Devam edersin yoluna biliyorum rahatça beni unutup<br /><br />

			Gözlerin ıslak , sesin titrek ararsan beni<br />
			Bilirsin yaşanmıştır bu hikâyeler gülüm<br />
			Dönmem gereksede birgün değiştirmez sözün<br />
			Yaşamadıksa da, doyamadıksa da hepsi mazidir<br />
		</div>

		<div class="is-hidden">
			<h3>Sessiz bir ezgi</h3>
			Kussam daha anlamlı olurdu dünyam!<br />
			Nefret parçacıkları, sevgi topakları...<br />
			Sevsem seni daha bir yokolurdum varoluşumdan...<br /><br />

			Penceremden giren rüzgar,habersiz, selamsız, uğuldar,<br />
			onca sazın sözün içinde,<br />
			sessiz bir ezgi var...<br /><br />

			İşte böyle uzaklaşıyorum tek hakikatimden,<br />
			Dünyada benim gibi onlarcasını gerçek kılabilecek dudaklarından...<br
			/><br />

			Sessiz bir ezgidir odamda,<br />
			Cıvıl parklarda bir salıncak, ağaç altlarındaki gölgeler gibi,<br />
			Bir çocuk mırıldansa ezgimi, anlamlı kılacak yazgımı...<br />
			Ama sessiz bir ezgiyim sokaklarında evrenin<br /><br />

			Söylenecek ne varsa saklanmış,<br />
			Bezenmiş dudaklarında,<br />
			Gözlerinde çekingenlik, korkutmasın seni,<br />
			Mırıldan da ezgimizi, gerçek kıl sevgimizi...<br /><br />

			Rüzgar girdi odama,<br />
			Selamsız, sabahsız...<br />
			Sessiz ezgimi mırıldadı aralıklardan,<br />
			İşte! Sevgimiz burda, sen neden uzaklardasın...<br />
			Ezgim söylenmeliydi dudaklarında...<br />
		</div>

		<h3 id="dreams">My dreams</h3>
		<p>
			This is another night without holding you in my arms...<br />
			Again and again unrecoverable seconds go by without plunging into your dreams...<br
			/><br />
			It's me again,<br />
			Swimming into the sea of your existence,<br />
			Breathing the lovely air,<br />
			Filling with expectations...<br /><br />
			Above, the dark clouds break the silence,<br />
			Raining over me one by one,<br />
			with a constant enthusiasm<br />
			Each drop is a screechy hit to the ground,<br />
			Irresistible call of life<br />
			Tearing down the drapery of a hopeless deaf,<br />
			An unusual feeling covering the veins,<br />
			With the blood pumping to each edge<br />
			Passion, addiction,<br />
			Climax of reincarnation,<br />
			Salvation from old habits,<br />
			Forming into new modality,<br />
			Impossibilities with realities,<br />
			Indispensable necessities,<br />
			This is not a world fulfilled with fantasies,<br />
			Just a confession,<br />
			Outbreak of paralysed forgotten thoughts...<br />
		</p>

		<div class="is-hidden">
			<h3>Düşman bildiklerini unut</h3>
			Şimdiye dek düşman bildiklerini unut sevgilim,<br />
			Yepyeni gününe doğan o eski güneş,<br />
			Mutluluk saçmayacak toprağına bugün!<br /><br />

			Düşman bildiklerini unut güzelim!<br />
			Bu sabah uyandığımda aklımda sen vardın yine,<br />
			Bildiğimiz uzun saçların ve yeşil gözlerin,<br />
			Yere uzanmıştı ruhsuz bedenin..<br /><br />

			Düşman bildiklerini unut!<br />
			Senin için kuşandım bugün!<br />
			Nefreti mahmuzlarım bedenimde,<br />
			Yükü omuzlarımda ağrının,<br />
			Çünkü senin için uyandım bugün,<br />
			Hergün yaptığım gibi senin için,<br />
			Ama bu sefer herzamankinden farklı,<br />
			Anılar kılıfı, öfkem silahımdır belimde..<br />
			Senin için sürdüm bir mermi hayatın namlusuna,<br />
			Tetiği çekilmiş zaten, kokusudur bu aşkının gelen..<br /><br />

			Bilirsin sensiz açamam gözlerimi,<br />
			Ama aklımda yine sen vardın hani dedim ya,<br />
			Ondan hiç açamam gözlerimi..<br /><br />

			Düşman bildiklerini unut!<br />
			Elimde gül ile geliyorum,<br />
			Kapın açık olsada olmasada, geliyorum güzelim,<br />
			Biliyorum çok yakışacak toprağına güller...<br />
		</div>
	</section>
</main>

<style>
	.written p {
		font-family: monospace;
		font-size: 1rem;
	}

	.is-hidden {
		display: none;
	}
</style>
